import * as React from "react";
import { RouteComponentProps, Route, Switch } from "react-router";
import ProductPage from "./product/ProductPage";
import ProductList from "./productList";

export interface Props extends RouteComponentProps<any>
{
    
}

const Products = ({ match: { path } }: Props) => (
    <>
        <Switch>
            <Route path={`${path}/edit/:productId`} component={ProductPage} />
            <Route path={`${path}/:productGroup?`} exact component={ProductList} />
        </Switch>
    </>
);

export default Products;


// WEBPACK FOOTER //
// ./src/components/product/Products.tsx